export default class Company {
  id?: number
  name?: string
}